import * as api from '../../api'
import React, { useCallback, useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import decode from 'jwt-decode'

import Logo from '../../images/logo.svg'

import { LOGOUT } from '../../constants/actionTypes'
import { ArrowDropDown, Close, DashboardOutlined, ExitToApp, Menu, SettingsOutlined } from '@material-ui/icons'

import Sidebar from '../../components/Sidebar/Sidebar'
import Index from '../../components/Client/Index/Index'
import Inactive from '../../components/Client/Inactive/Inactive'
import Ongoing from '../../components/Client/Ongoing/Ongoing'
import Completed from '../../components/Client/Completed/Completed'
import Project from '../../components/Client/Project/Project'

import { ALERT } from '../../constants/actionTypes'

import './Client.css'
import { Search } from '@material-ui/icons'

const Client = ({ match }) => {
    const dispatch = useDispatch()
    const section = match.params.section
    const history = useHistory()
    const location = useLocation()
    const [user, setUser] = useState({})
    const [fetching, setFetching] = useState(true)
    const [quoteFocused, setQuoteFocused] = useState(false)
    const [quoteId, setQuoteId] = useState('')
    const [fetchingQuote, setFetchingQuote] = useState(true)
    const [showDetails, setShowDetails] = useState(false)
    const [quote, setQuote] = useState({})
    const [showSidebar, setShowSidebar] = useState(false)
    const [auth, setAuth] = useState(JSON.parse(localStorage.getItem('auth')))

    const handleFetchQuote = async (e) => {
        e.preventDefault()
        setShowDetails(true)

        try {
            const { data } = await api.getOneQuote({ quote_id: quoteId })
            setQuote(data)
            setFetchingQuote(false)
        } catch (error) {
            setShowDetails(false)
            if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
            else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
        }
    }

    const logout = useCallback(() => {
        if(!auth) history.push('/auth/signin')

        setAuth(null)
        dispatch({ type: LOGOUT })
    }, [dispatch, history, auth])

    const handleToDashboard = () => {
        if(auth.role === 'basic') history.push('/projects/index')
        if(auth.role === 'translator') history.push('/translator/profile')
        if(auth.role === 'admin') history.push('/admin/index')
    }

    useEffect(() => {
        const token = auth?.token

        if(token) {
            const decodedToken = decode(token)

            if(decodedToken.exp * 1000 < new Date().getTime()) logout()
        }

        if(!auth) return history.replace('/auth/sign')

        if(auth.role !== 'basic') return history.replace('/not-found')
    }, [auth, location, history, logout])

    useEffect(() => {
        const getUser = async () => {
            try {
                const { data } = await api.getUser({ email: JSON.parse(localStorage.getItem('auth')).email })
                setUser(data)
            } catch (error) {
                if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
                else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
            } finally {
                setFetching(false)
            }
        }

        if(auth?.role === 'basic') getUser()
    }, [auth, dispatch])

    return (
        <>
            {auth?.role === 'basic' &&
              <>
                {showSidebar && <div className="client__overlay z-2" onClick={() => setShowSidebar(false)}></div>}
                {showDetails && <Project showDetails={showDetails} setShowDetails={setShowDetails} quote={quote} getting={fetchingQuote} preview/>}
                <div className="client d-flex f-100">
                    <aside style={{ left: showSidebar ? '0' : '' }} className="z-3">
                        <Link to="/">
                            <div className="navBar__logo m-10">
                                <img src={Logo} alt="OneConverse" />
                            </div>
                        </Link>

                        <Close className="sidebar__close position-absolute t-0 r-0 m-5" onClick={() => setShowSidebar(false)} />

                        <Sidebar section={section} setShowSidebar={setShowSidebar} client/>
                    </aside>
                    <main className="py-10 pb-40">
                        <div className="client__topBar px-40">
                            <div className="d-flex align-center justify-between py-10">
                                <Menu className="client__logo" onClick={() => setShowSidebar(true)} />
                                <div className="d-flex align-center justify-end w-100">
                                    <form className="client__big__form mx-20" onSubmit={handleFetchQuote}>
                                        <label style={{ width: quoteFocused ? '500px' : '' }} className="client__label d-flex align-center px-10 border-1 rounded">
                                            {!quoteFocused && <Search className="icon-light-grey" />}
                                            <input className="bg-transparent border-0 outline-0 p-10" type="text" placeholder="Enter project ID" value={quoteId}
                                            onFocus={() => setQuoteFocused(true)} onBlur={() => {setQuoteFocused(false); setQuoteId('')}} onChange={e => setQuoteId(e.target.value)} />
                                        </label>
                                    </form>
                                    {auth && 
                                        <details className="navBar__details position-relative">
                                            <summary className="d-flex align-center list-none pointer">
                                                <div className="holder__logo d-flex align-center justify-center font-subhead font-bolder text-center rounded-50">
                                                    <span className="text-uppercase">{auth.name.split(' ')[0].charAt(0)}</span>
                                                </div>
                                                <ArrowDropDown className="icon-light-grey" fontSize="large" />
                                            </summary>
                                            <div className="navBar__drop position-absolute r-0 mt-20 z-3 box-shadow-lg">
                                                <p className="text-capitalise font-big font-bolder text-center px-40 my-10">Hi, {auth.name.split(' ')[0]}</p>
                                                <div className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer" onClick={handleToDashboard}>
                                                    <DashboardOutlined fontSize="small" className="mr-20" />
                                                    <span>Your Dashboard</span>
                                                </div>
                                                <div className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer" onClick={() => history.push('/settings')}>
                                                    <SettingsOutlined fontSize="small" className="mr-20" />
                                                    <span>Settings</span>
                                                </div>
                                                <div style={{ color: 'crimson' }} className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer" onClick={logout}>
                                                    <ExitToApp fontSize="small" className="mr-20" />
                                                    <span>Log Out</span>
                                                </div>
                                            </div>
                                        </details>
                                    }
                                </div>
                            </div>
                            <form className="client__sm__form w-100 my-20 pb-20" onSubmit={handleFetchQuote}>
                                <label className="d-flex align-center px-10 border-1 rounded w-100">
                                    {!quoteFocused && <Search className="icon-light-grey" />}
                                    <input className="border-0 outline-0 p-10 w-100" type="text" placeholder="Enter project ID" value={quoteId}
                                    onFocus={() => setQuoteFocused(true)} onBlur={() => {setQuoteFocused(false); setQuoteId('')}} onChange={e => setQuoteId(e.target.value)} />
                                </label>
                            </form>
                        </div>
                        <div className="client__p20__1024 px-40">
                            {section === "index" && <Index user={user} fetching={fetching} />}
                            {section === "inactive" && <Inactive user={user} fetching={fetching} />}
                            {section === "ongoing" && <Ongoing user={user} fetching={fetching} />}
                            {section === "completed" && <Completed user={user} setUser={setUser} fetching={fetching} />}
                        </div>
                    </main>
                </div>
              </>
            }
        </>
    )
}

export default Client
